import { Button, FlexCell, FlexRow, Panel } from '@epam/promo';
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { ReactComponent as plusIcon } from '@epam/assets/icons/common/action-add-12.svg';
import { resetDraft, useTaskStore } from 'store/task.store';
import { CardList, TaskFilters } from 'components/tasks';
import { useTaskGetAllQuery, useTaskGetQuery, useTaskSwitcher } from 'hooks';
import css from './TaskPage.module.scss';
import { BlankBlock } from 'components/common';

export const TaskPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams<{ taskId: string }>();
  const switchTask = useTaskSwitcher();
  const draftTask = useTaskStore((state) => state.draft);
  const { data: task } = useTaskGetQuery(draftTask?.id ?? '');
  const { data: tasks } = useTaskGetAllQuery();

  if (task && !params.taskId && location.pathname !== '/tasks/create') {
    return <Navigate replace to={`/tasks/${draftTask.id}`} />;
  }

  if (
    tasks?.length &&
    !params.taskId &&
    location.pathname !== '/tasks/create'
  ) {
    return <Navigate replace to={`/tasks/${tasks[0].id}`} />;
  }

  if (params.taskId && params.taskId.length !== 24) {
    return <Navigate replace to="/tasks" />;
  }

  return (
    <FlexRow cx={css.page__container}>
      <FlexCell grow={1}>
        <Button
          caption="Add new task"
          color="blue"
          cx={css.page__btn}
          icon={plusIcon}
          onClick={() =>
            switchTask({
              onSuccess: () => {
                navigate('/tasks/create');
                resetDraft();
              },
              onAbort: () => {
                navigate('/tasks/create');
                resetDraft();
              },
            })
          }
        />
        {(tasks?.length || location.pathname === '/tasks/create') && (
          <>
            <TaskFilters />
            <CardList
              items={
                location.pathname === '/tasks/create'
                  ? [draftTask, ...tasks]
                  : [...tasks]
              }
            />
          </>
        )}
      </FlexCell>
      <FlexCell grow={2.5}>
        <Panel shadow cx={css.page__panel}>
          {tasks?.length || location.pathname === '/tasks/create' ? (
            <Outlet />
          ) : (
            <BlankBlock message="Please create your first user task" />
          )}
        </Panel>
      </FlexCell>
      {process.env.NODE_ENV !== 'development' && <FlexCell grow={1} />}
    </FlexRow>
  );
};
